import { drawBackground } from "../../../utils/scene-background";
import { SceneId } from "../../../../shared/enum";
import { TitleMenu } from "../../../menu/title-screen/title-menu";

export class TitleMenuScene extends Phaser.Scene {
    private menu: TitleMenu;

    constructor() {
        super({ key: SceneId.TITLE_SCREEN });
    }

    init() {
        this.sys.events.on("wake", () => this.scene.bringToTop());
    }

    public create(sceneId: string) {
        drawBackground(this);
        const screenWidth = this.physics.world.bounds.width;
        const screenHeight = this.physics.world.bounds.height;
        this.menu = new TitleMenu(0, 0, screenWidth, screenHeight, this);
        this.menu.draw();
    }
}
